<template>
  <v-dialog persistent v-model="dialog" :max-width="1000">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Sign up</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <AlertBar
        v-model="message.show"
        :type="message.type"
        :message="message.text"
        :detail="message.detail"
      >
      </AlertBar>
      
      <v-card-text class="pt-8 px-8 text-center">
        <div class="text-left text-subtitle-1">Sign up is quick and easy!  Just complete the form below and then we'll email you an activation link.<br/></div>
        <RegistrationForm
          ref="registrationForm"
          :value="account"
          @input="updateAccountField"
        >
        </RegistrationForm>                
        <div class="text-left text-caption">
          <br/>          
          <span>
            Our <a target="_blank" href="https://hexagon.com/legal/privacy-notice">Privacy Notice</a> describes how we process Personal Data about you. It also provides information on how you may exercise any of your rights as a Data Subject. You have the right to withdraw your consent at any time by clicking on the "Unsubscribe" link within the electronic marketing communications sent to you. By submitting this form, you agree to our <a target="_blank" href="https://hexagon.com/legal/terms-of-use">Terms of Use</a>.
          </span>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <span class="pb-4">
        <v-btn color="primary" @click="createAccount" :disabled="!inputIsValid">Create Account</v-btn>
        <v-btn class="ml-4" text @click="cancel">Cancel</v-btn>        
        </span>
      </v-card-actions>
    </v-card>      
    <Busy :value="busy"></Busy>
  </v-dialog>
</template>
<script>
import axios from 'axios'
import RegistrationForm from './RegistrationForm'
import { AlertBar, Busy, ExceptionMessage } from '@itus/ui.common'
import { v4 as uuidv4 } from 'uuid'
import { buildApiUrl } from '@/components/api-url-builder'
import { mapState } from 'vuex'


export default {
  name: 'RegistrationDialog',
  data() {
    return {
      dialog: false,
      resolve: null,
      busy: false,      
      message: {show:false},
      account: {
        lastName: null,
        firstName: null,
        email: null,
        title: null,
        roleName: null,
        company: null,
        industry: null,
        country: null,
        marketingOptIn: false,
        readyToSpeakWithSales: false,
        partner: null,
        utmTerm: null,
        utmMedium: null,
        utmCampaign: null,
        utmContent: null,
        utmSource: null
      }
    }
  },
  components: {
    RegistrationForm,    
    Busy,
    AlertBar
  },
  computed: {
    ...mapState({
      utms: state => state.utms
    }),
    inputIsValid() {
      return this.account && this.account.lastName && this.account.firstName && this.account.email && this.account.company && this.account.country
    }
  },
  watch: {
    utms: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.account.partner = newVal?.partner
        this.account.utmTerm = newVal?.utmTerm
        this.account.utmMedium = newVal?.utmMedium
        this.account.utmCampaign = newVal?.utmCampaign
        this.account.utmContent = newVal?.utmContent
        this.account.utmSource = newVal?.utmSource
      }
    }
  },
  methods: {
    updateAccountField(v) {
      if(v.field === 'lastName')
        this.account.lastName = v.value
      else if(v.field === 'firstName')
        this.account.firstName = v.value
      else if(v.field === 'email')
        this.account.email = v.value
      else if(v.field === 'title')
        this.account.title = v.value
      else if(v.field === 'roleName')
        this.account.roleName = v.value
      else if(v.field === 'company')
        this.account.company = v.value
      else if(v.field === 'industry')
        this.account.industry = v.value
      else if(v.field === 'country')
        this.account.country = v.value
      else if(v.field === 'marketingOptIn')
        this.account.marketingOptIn = v.value
      else if(v.field === 'readyToSpeakWithSales')
        this.account.readyToSpeakWithSales = v.value
    },
    show() {      
      this.account = {
        lastName: null,
        firstName: null,
        email: null,
        title: null,
        roleName: null,
        company: null,
        industry: null,
        country: null,
        marketingOptIn: false,
        readyToSpeakWithSales: false,
        partner: this.utms?.partner,
        utmTerm: this.utms?.utmTerm,
        utmMedium: this.utms?.utmMedium,
        utmCampaign: this.utms?.utmCampaign,
        utmContent: this.utms?.utmContent,
        utmSource: this.utms?.utmSource
      }
      
      this.dialog = true      
      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    showException(err, defaultMsg) {
      this.message = ExceptionMessage.generateMessage(err, defaultMsg)
    },    
    async createAccount () {
      this.message.show = false
      if(!this.$refs.registrationForm.validate())
        return

      this.busy = true
      try {
        let registrationId = uuidv4()
        await axios.post(buildApiUrl('/api/register'), {
          step: 'account',
          id: registrationId,
          firstName: this.account.firstName,
          lastName: this.account.lastName,
          email: this.account.email,
          title: this.account.title,
          roleName: this.account.roleName,
          company: this.account.company,
          industry: this.account.industry,
          country: this.account.country,
          marketingOptIn: this.account.marketingOptIn,
          readyToSpeakWithSales: this.account.readyToSpeakWithSales,
          partner: this.account.partner,
          utmTerm: this.account.utmTerm,
          utmMedium: this.account.utmMedium,
          utmCampaign: this.account.utmCampaign,
          utmContent: this.account.utmContent,
          utmSource: this.account.utmSource
        })
        this.$gtag.event('sign_up')
        this.resolve(registrationId)            
        this.dialog = false      
      } catch(err) {
        this.showException(err, 'Error creating account.')
      } finally {
        this.busy = false      
      }
    },
    cancel() {
      this.dialog = false
      this.resolve(null)
    },
  }
}
</script>